<template>
  <div>

    <CRow>
      <CCol col="8">
        <CCard>
          <CCardHeader>
            <CRow>
              <CCol col="8" style="text-align: start ;padding:10px 20px 0 20px ">

                <strong>شیفت ها</strong>
              </CCol>
              <CCol col="4" style="text-align: end">

                <CButton color="primary" @click="status_form=0,dialog_add_holiday = true">افزودن شیفت</CButton>

              </CCol>
            </CRow>
          </CCardHeader>

          <CCardBody>

            <CDataTable
                :items="items"
                :fields="fields"
                :items-per-page="10"
                hover
                sorter
                striped
                border
                column-filter
                pagination
            >
              <template #row="{item,index}">
                <td style="text-align: center">
                  <p >{{ index + 1 }}</p>
                </td>
              </template>
              <template #date="{item}">
                <td style="text-align: center">
                  <p >{{get_date(item.date)}}</p>
                </td>
              </template>

              <template #operation="{item}">
                <td>
                  <!--                            <CIcon @click.native="goSubCategories(item)" class="mr-1 text-success"-->
                  <!--                                   name="cilApplications"/>-->

                  <CIcon @click.native="edit_item(item)" class=" mr-1 text-primary" name="cil-pencil"/>

                                      <CIcon @click.native="delete_item_dialog(item)" class="mr-1 text-danger" name="cilTrash"/>

                </td>
              </template>


            </CDataTable>

          </CCardBody>
        </CCard>
      </CCol>

    </CRow>

    <CModal :title="status_form==0? 'افزودن شیفت' : 'ویرایش شیفت'" :show.sync="dialog_add_holiday">
      <CRow>
        <CCol col="12">
          <CInput
              v-model="title"
                  label="عنوان"
          />
        </CCol>
        <CCol col="6">
          <date-picker
              v-model="start_time"
              type="time"
              format="HH:mm"
              label="ساعت شروع"
          />
        </CCol>
        <CCol col="6">
          <date-picker
              v-model="end_time"
              format="HH:mm"
              type="time"

              label="ساعت پایان"
          />
        </CCol>
      </CRow>

      {{start_time}}


      <template #footer>
        <CButton @click="dialog_add_holiday = false,send_data()" color="dark">{{ $t('buttons.ok') }}</CButton>
        <CButton @click="dialog_add_holiday = false" color="dark">{{ $t('buttons.cancel') }}</CButton>

      </template>
    </CModal>

  </div>

</template>

<script>
import axios from "axios";
import {bus} from '../../../main';
import moment from 'moment-jalaali'

import Vue from "vue";

export default {
  name: 'Login',
  data() {
    return {
      dialog_add_holiday: false,
      confirm_delete_name: "confirm_delete_holiday" + new Date().getTime() + "_" + this.$vnode.tag,
      title: '',
      start_time: '',
      end_time: '',
      items: [],
      fields: [
        {key: 'row', label: 'ردیف', _style: 'width:10%'},
        {key: 'title', label: "عنوان", _style: 'width:20%'},
        {key: 'start_time', label: "ساعت شروع", _style: 'width:20%;'},
        {key: 'end_time', label: "ساعت پایان", _style: 'width:20%;'},
        {key: 'operation', label: "عملیات", _style: 'width:20%;'},

      ],
      status_form: 0,

    }
  },
  mounted() {
    this.$root.root_validate_errors = [];
    this.get_data_detail()
    bus.$on(this.confirm_delete_name, (data) => {
      // alert(data);
      if (data == "true") {
        this.delete_holiday();

      } else {
        this.status_form = 0;
      }
    });
  }, watch: {},
  methods: {

edit_item(item){
  this.status_form=item.id
  this.title=item.title
  this.start_time=item.start_time
  this.end_time=item.end_time


  this.dialog_add_holiday=true
},
    send_data() {
      var self = this;
      const formData = new FormData();
      var url = "add_shift";
      var its = [];
      if (this.status_form != 0) {
        url = "edit_shift"
        formData.append("id", this.status_form);

      }

      // console.log("items",its);
      formData.append("title", this.title);
      formData.append("start_time", this.start_time);
      formData.append("end_time", this.end_time);
      axios.post(url, formData, {}).then(function (response) {

        // var content_data = response.data;
        self.$root.modal_component.show_api_response_modals(response);
        self.items = [];
        self.get_data_detail();

      })
          .catch(function (error) {

            console.log(error);
          });

    },

    get_data_detail() {

      let self = this;
      const formData = new FormData();
      let url = "get_shifts";

      axios.post(url, formData, {}).then((res) => {

        self.items = res.data

      })
          .catch(function (error) {
            console.log(error);
          });

    },
    delete_item_dialog(item) {
      this.$root.modal_component.show_confirm_modal(this.$t("dialogs.warning"), this.$t("dialogs.deleteMessage"), [this.$t("dialogs.ok")], this.confirm_delete_name);

      this.status_form = item.id;

    },
    delete_holiday() {

      let self = this;
      const formData = new FormData();
      let url = "delete_shift";
      formData.append('id', this.status_form);

      axios.post(url, formData, {}).then((res) => {
        self.get_data_detail()

      }).catch(function (error) {
        console.log(error);
      });

    },
  }
}

</script>
<style>
.bg-yellow {
  background: #ffee3f;
}
</style>
